export default __webpack_public_path__ + "91b101e5fab6e795bcd7e06c8a3b9ebf.png";